import React from "react";
import { Redirect, Route } from "react-router-dom";
import { Alert, Button, Space, Spin } from "antd";
import { firstAccessiblePath, hasPermission } from "./permissions";
import { useAuth } from "./session";

export default function PrivateRoute({ permission, children, ...routeProps }) {
  const { user, loading, restoreError, retryRestore } = useAuth();

  return (
    <Route
      {...routeProps}
      render={({ location }) => {
        if (loading) return <Spin size="large" tip="Đang xác thực..." />;
        if (restoreError) {
          return (
            <Space direction="vertical" style={{ margin: 24 }}>
              <Alert type="warning" showIcon message={restoreError} />
              <Button type="primary" onClick={retryRestore}>Thử lại</Button>
            </Space>
          );
        }
        if (!user) return <Redirect to={{ pathname: "/sign-in", state: { from: location } }} />;
        if (permission && !hasPermission(user, permission)) return <Redirect to={firstAccessiblePath(user)} />;
        return children;
      }}
    />
  );
}
